import { IModules } from "~/lib/data-contract";
import { PrefetchContext } from "./prefetch-data";

export async function pageElementPrefetch(_element: IModules, _context: PrefetchContext): Promise<void> {
    // Expand with a switch, when we need to prefetch Block-specific data.
    return Promise.resolve();
}
